import { useRef, useState } from 'react';
import { SwiperSlide } from 'swiper/react';
import getAlphabet from 'utils/getAlphabet';
import CarouselArrow from '@/UI/Primitives/CarouselArrow';
import { SliderArrowRight, SliderArrowLeft } from '@/UI/Icons';
import {
  Alpha,
  AlphabetSwiper,
  AlphabetSwiperContainer,
  Arrow,
  SelectionContainer
} from './styles';

export default function AlphabetCarousel() {
  const swiperRef = useRef(null);

  const [selected, setSelected] = useState(null);
  const [arrows, setArrows] = useState({ left: false, right: true });

  const alphabet = getAlphabet();

  const scrollToAlpha = alpha => {
    setSelected(alpha);

    const element = document.getElementById(alpha);
    element.scrollIntoView();
  };

  return (
    <SelectionContainer>
      <span>Kõik brändid</span>
      <AlphabetSwiperContainer>
        {arrows.left && (
          <Arrow prev>
            <CarouselArrow
              onClick={() => swiperRef.current?.swiper.slidePrev()}
            >
              <SliderArrowLeft strokeWidth={5} />
            </CarouselArrow>
          </Arrow>
        )}
        <AlphabetSwiper
          ref={swiperRef}
          freemode="true"
          slidesPerView="auto"
          spaceBetween={16}
          onFromEdge={() => {
            setArrows({ left: true, right: true });
          }}
          onReachBeginning={() => {
            setArrows({ left: false, right: true });
          }}
          onReachEnd={() => {
            setArrows({ left: true, right: false });
          }}
        >
          {alphabet.map(alpha => {
            return (
              <SwiperSlide key={alpha}>
                <Alpha
                  role="button"
                  aria-label="Select brand letter"
                  selected={selected === alpha}
                  onClick={() => scrollToAlpha(alpha)}
                >
                  {alpha.toUpperCase()}
                </Alpha>
              </SwiperSlide>
            );
          })}
        </AlphabetSwiper>
        {arrows.right && (
          <Arrow next>
            <CarouselArrow
              onClick={() => swiperRef.current?.swiper.slideNext()}
            >
              <SliderArrowRight strokeWidth={5} />
            </CarouselArrow>
          </Arrow>
        )}
      </AlphabetSwiperContainer>
    </SelectionContainer>
  );
}
